export default "__VITE_ASSET__CDR8_smK__"